import React, { useEffect } from "react";
import Box from "../../components/Box";
import { useNavigate } from "react-router";
import { useKpiVisibility } from "../../kpis/useKpiVisibility";

function Default() {
  const navigate = useNavigate();
  const {isModuleExists} = useKpiVisibility();

  useEffect(() => {
    navigate("/ecom/drive");
  }, [navigate]);

  if(!isModuleExists("Ecommerce")){
    return null;
  }
  
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent={["space-between", "flex-start"]}
      flex="1"
    ></Box>
  );
}

export default Default;
